import React,{useState} from 'react'
import './prodcard.css'

const Prodcard1 = ({ imageSrc, altText, title, description,model}) => {
  const [showModal, setShowModal] = useState(false);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);
    return (
      <div>
      <div className="card1" onClick={openModal}>
        <img src={imageSrc} alt={altText} height="250" width="300" />
        <div className="card-content">
          <h3>{title}</h3>
          <h4>Model no:{model}</h4>
          <h5>view all</h5>
          {/* <ul>
          {description.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul> */}
        </div>
      </div>

       {/* Modal */}
       {showModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <span className="close-button" onClick={closeModal}>
              &times;
            </span>
            <img src={imageSrc} alt={altText} height="250" width="300" />
            <h3>{title} - {model}</h3>
            <h4>description</h4>
            <ul>
              {description.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      )}

      </div>
  )
}

export default Prodcard1